var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForumArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_3867_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25005 3.75L5.3688 4.63125L8.2313 7.5L5.3688 10.3688L6.25005 11.25L10.0001 7.5L6.25005 3.75Z",
    fill: "#956D84"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip1_3867_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 3.75L11.3688 4.63125L14.2313 7.5L11.3688 10.3688L12.2501 11.25L16.0001 7.5L12.2501 3.75Z",
    fill: "#956D84"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#clip2_3867_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2501 3.75L17.3688 4.63125L20.2313 7.5L17.3688 10.3688L18.2501 11.25L22.0001 7.5L18.2501 3.75Z",
    fill: "#956D84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3867_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3867_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3867_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumArrow);
export default __webpack_public_path__ + "static/media/forum_arrow.f5b2da61abacd13f200021ac0adbb1ab.svg";
export { ForwardRef as ReactComponent };